import { makeAutoObservable } from 'mobx';
import { NodeValueType } from './utils';
import { Common } from 'src/AppState/Common';
import { openapiSocketGetCompetitionRequest } from 'src/api_openapi/generated/openapi_socket_get_competition';
import { openapiSocketGetEventRequest } from 'src/api_openapi/generated/openapi_socket_get_event';
import { openapiSocketGetMarketRequest } from 'src/api_openapi/generated/openapi_socket_get_market';
import { convertToNumber } from 'src_common/common/mobx-utils/Form2/validators';

export class SportDetailsLoader {
    public constructor(private readonly common: Common) {
        makeAutoObservable(this);
    }

    public fetchCompetition = async (competitionId: string): Promise<NodeValueType | null> => {
        const converter = convertToNumber('Invalid competitionId');
        const competitionIdNum = converter(competitionId);

        if (competitionIdNum.value.type === 'error') {
            return null;
        }

        const response = await this.common.session.call(openapiSocketGetCompetitionRequest, {
            id: competitionIdNum.value.data,
        });
        const sportId = response.result?.sport;

        if (sportId === undefined) {
            return null;
        }

        return {
            type: 'competition',
            sportId,
            competitionId: competitionId.toString(),
        };
    };

    public fetchEvent = async (eventId: string): Promise<NodeValueType | null> => {
        const converter = convertToNumber('Invalid eventId');
        const eventIdNum = converter(eventId);

        if (eventIdNum.value.type === 'error') {
            return null;
        }

        const response = await this.common.session.call(openapiSocketGetEventRequest, {
            id: eventIdNum.value.data,
        });
        const sportId = response.result?.sport;
        const competitionId = response.result?.competition;

        if (sportId === undefined || competitionId === undefined) {
            return null;
        }

        return {
            type: 'event',
            sportId,
            competitionId: competitionId.toString(),
            eventId,
        };
    };

    public fetchMarket = async (marketId: string): Promise<NodeValueType | null> => {
        const converter = convertToNumber('Invalid marketId');
        const marketIdNum = converter(marketId);

        if (marketIdNum.value.type === 'error') {
            return null;
        }

        const marketResponse = await this.common.session.call(openapiSocketGetMarketRequest, {
            id: marketIdNum.value.data,
        });
        const eventId = marketResponse.result?.eventId;

        if (eventId === undefined) {
            return null;
        }

        const eventResponse = await this.fetchEvent(eventId.toString());

        if (eventResponse === null || eventResponse.type !== 'event') {
            return null;
        }

        return {
            type: 'market',
            sportId: eventResponse.sportId,
            competitionId: eventResponse.competitionId,
            eventId: eventResponse.eventId,
            marketId,
        };
    };
}
